import React from 'react';

export interface Props {
	active: boolean;
	hidden: boolean;
	value: number | null;
	onClick(value: number): void;
}

export function PaginationBtn({ value, active, hidden, onClick }: Props) {
	return (
		<button
			aria-current='page'
			className={`relative py-2 text-md font-display leading-tight text-center transition ${hidden ? 'hidden' : ''} ${
				value !== null
					? 'min-w-[40px] px-3 text-gray-500 hover:text-cPurple-800 hover:bg-gray-100'
					: 'px-2.5 text-gray-300 bg-transparent'
			} ${active ? 'z-10 !text-white !bg-cPurple-800 !cursor-default' : ''}`}
			disabled={value === null}
			onClick={() => {
				onClick(value !== null ? value : 1);
			}}
		>
			<span>{value !== null ? value : '...'}</span>
		</button>
	);
}
